import React, { useState } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { IoMdSearch } from "react-icons/io";
import { FaXmark } from "react-icons/fa6";

function PickColumn() {
  const [showOn, setShowOn] = useState(false);
  return (
    <div>
      <div
        className="group relative cursor-pointer"
        onClick={() => setShowOn(true)}
      >
        <div
          data-tooltip-id="main-tooltip"
          data-tooltip-content="Pick Column"
          className="text-sm bg-gray-200 text-gray-600 shadow-sm
            font-semibold rounded-md px-4 py-1.5 flex gap-2
            items-center justify-center text-center border
            border-transparent 
            hover:text-gray-800 transition-all"
        >
          Pick Column
        </div>
      </div>
      <ReactTooltip
        id="main-tooltip"
        place="top"
        effect="solid"
        className="!text-[14px] !rounded-md !px-5 !py-[2px] !text-white z-20 shadow-md"
      />
      {showOn && <Pickup_Pop open={showOn} onClose={() => setShowOn(false)} />}
    </div>
  );
}

export default PickColumn;

function Pickup_Pop({ open, onClose }) {
  const [selectedColumns, setSelectedColumns] = useState([]);

  const basicDetails = [
    "Company ID",
    "Company Name",
    "Company Website URL",
    "Nature of Business",
    "Primary Email ID",
    "Additional Email ID",
    "Primary Contact Number",
    "Additional Contact Number ",
    "Company LinkedIn URL",
  ];
  const geoDetails = [
    "Country",
    "State",
    "City / District",
    "Locality",
    "Street",
    "Pin Code",
  ];

  const executives = [
    "Name",
    "Designation",
    "Organisational Hierarchy",
    "Email ID",
    "Primary Contact Number",
    "Additional Contact Number ( separated by ; )",
    "Preferred Instant Message - 1",
    "Preferred Instant Message - 1 ID",
    "Preferred Instant Message - 2",
    "Preferred Instant Message - 2 ID",
    "Personal LinkedIn Page",
  ];
  const otherBusinessDetails = [
    "Tax ID",
    "Preferred Currency",
    "Organisational Hierarchy",
    "Year of Incorporation",
    "Primary Contact Number",
    "Additional Contact Number ( separated by ; )",
    "Preferred Instant Message - 1",
    "Preferred Instant Message - 1 ID",
    "Preferred Instant Message - 2",
    "Preferred Instant Message - 2 ID",
    "Personal LinkedIn Page",
  ];
  const productDetails = [
    "Product Name",
    "Categories of Product",
    "HSN code of Products",
    "Required Quantity of Product",
    "Indicative Target Price Range",
  ];

  const toggleColumn = (label) => {
    setSelectedColumns((prev) =>
      prev.includes(label)
        ? prev.filter((col) => col !== label)
        : [...prev, label]
    );
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
      <ReactTooltip
        id="main-cancel"
        place="top"
        effect="solid"
        className="!text-[14px] !rounded-md !px-5 !py-[2px]  !text-white z-20 shadow-md"
      />{" "}
      <div className="bg-white w-full max-w-2xl rounded-2xl shadow p-5 relative">
        <div className="w-full flex justify-between mb-3">
          <h2 className="text-2xl  text-gray-900 font-semibold text-center">
            Pick Columns
          </h2>
          <button
            data-tooltip-id="main-cancel"
            data-tooltip-content="Cancel"
            onClick={onClose}
            className=" text-gray-500 hover:text-red-500 text-xl"
          >
            <FaXmark size={25} />
          </button>
        </div>

        <hr />
        <InputSearch />

        <div
          className="overflow-y-auto px-5 my-4  space-y-6 "
          style={{ maxHeight: "380px" }}
        >
          {/* 1 */}
          <div className="mb-4">
            <h3 className="font-semibold text-gray-800 text-lg mb-2 underline">
              Basic Details
            </h3>
            <div className="grid grid-cols-2 gap-2">
              {basicDetails.map((item) => (
                <label
                  key={item}
                  className="flex text-sm font-normal text-gray-700 items-center space-x-2"
                >
                  <input
                    type="checkbox"
                    checked={selectedColumns.includes(item)}
                    onChange={() => toggleColumn(item)}
                  />
                  <span>{item}</span>
                </label>
              ))}
            </div>
          </div>

          {/* 2 */}
          <div className="mb-4">
            <h3 className="font-semibold text-gray-800 text-lg mb-2 underline">
              Geo Details
            </h3>
            <div className="grid grid-cols-2 gap-2">
              {geoDetails.map((item) => (
                <label
                  key={item}
                  className="flex text-sm font-normal text-gray-700 items-center space-x-2"
                >
                  <input
                    type="checkbox"
                    checked={selectedColumns.includes(item)}
                    onChange={() => toggleColumn(item)}
                  />
                  <span>{item}</span>
                </label>
              ))}
            </div>
          </div>

          {/* 3 */}
          <div className="mb-4">
            <h3 className="font-semibold text-gray-800 text-lg mb-2 underline">
              Executives
            </h3>
            <div className="grid grid-cols-2 gap-2">
              {executives.map((item) => (
                <label
                  key={item}
                  className="flex text-sm font-normal text-gray-700 items-center space-x-2"
                >
                  <input
                    type="checkbox"
                    checked={selectedColumns.includes(item)}
                    onChange={() => toggleColumn(item)}
                  />
                  <span>{item}</span>
                </label>
              ))}
            </div>
          </div>

          {/* 4 */}
          <div className="mb-4">
            <h3 className="font-semibold text-gray-800 text-lg mb-2 underline">
              Other Business Details
            </h3>
            <div className="grid grid-cols-2 gap-2">
              {otherBusinessDetails.map((item) => (
                <label
                  key={item}
                  className="flex text-sm font-normal text-gray-700 items-center space-x-2"
                >
                  <input
                    type="checkbox"
                    checked={selectedColumns.includes(item)}
                    onChange={() => toggleColumn(item)}
                  />
                  <span>{item}</span>
                </label>
              ))}
            </div>
          </div>

          {/* 5 */}
          <div className="mb-4">
            <h3 className="font-semibold text-gray-800 text-lg mb-2 underline">
              product Details
            </h3>
            <div className="grid grid-cols-2 gap-2">
              {productDetails.map((item) => (
                <label
                  key={item}
                  className="flex text-sm font-normal text-gray-700 items-center space-x-2"
                >
                  <input
                    type="checkbox"
                    checked={selectedColumns.includes(item)}
                    onChange={() => toggleColumn(item)}
                  />
                  <span>{item}</span>
                </label>
              ))}
            </div>
          </div>
        </div>

        <div className="w-full flex justify-end">
          <button
            onClick={() => {
              console.log("Selected Columns:", selectedColumns);
              onClose();
            }}
            className="m-0 bg-sky-600 hover:bg-sky-700 text-white py-1.5 px-6 rounded"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
}

function InputSearch() {
  const [searchText, setSearchText] = useState("");

  return (
    <div
      className="group relative bg-gray-200  flex items-center justify-between mt-2 rounded-md px-3  shadow-md border  border-gray-300 transition "
      style={{ paddingBottom: "5px", paddingTop: "5px" }}
    >
      <ReactTooltip
        id="main-search"
        place="top"
        effect="solid"
        className="!text-[14px] !rounded-md !px-5 !py-[2px]  !text-white z-20 shadow-md"
      />
      <input
        type="text"
        placeholder="Search"
        className="bg-transparent outline-none w-full text-black-400 border-none font-normal   m-0 p-0  placeholder-gray-400"
        value={searchText}
        onChange={(e) => {
          const value = e.target.value;
          setSearchText(value);
        }}
      />
      <IoMdSearch
        data-tooltip-id="main-search"
        data-tooltip-content="Search"
        size={22}
        className="text-gray-400 outline-none transition-colors"
      />
    </div>
  );
}
